import { ReactComponent as IconDataElement } from '@/assets/svgs/package-data-elements.svg'
import { ReactComponent as IconAttachment } from '@/assets/svgs/package-attachments-icon.svg'
import moment from "moment";
import PropTypes from 'prop-types';

const PackageBasicInformation = ({ packageInfo }) => {

    return (
		<div className="package-basic__container">
			<div>
				<div className="package-basic__heading">{"Template"}</div>
				<div className="package-basic__content">{packageInfo.template}</div>
			</div>
			<div>
				<div className="package-basic__heading">{"Created On"}</div>
				<div className="package-basic__content">{moment(new Date(packageInfo.created)).format(
							"DD/MM/yyyy"
						)}</div>
			</div>
			<div>
				<div className="package-basic__heading">{"Last Modified On"}</div>
				<div className="package-basic__content">{moment(new Date(packageInfo.modified)).format(
							"DD/MM/yyyy"
						)}</div>
			</div>
			<div className="package-basic__document-stats">
				<span className="package-basic__document-stats__icon"><IconDataElement /></span>
				<span className="package-basic__document-stats__data">{packageInfo.dataElementsCount}</span>
				<span className="package-basic__document-stats__icon package-basic__document-stats__margin"><IconAttachment /></span>
				<span className="package-basic__document-stats__data">{packageInfo.attachmentsCount}</span>
			</div>
		</div>
    )

};

export default PackageBasicInformation;

PackageBasicInformation.propTypes = {
	packageInfo: PropTypes.shape({
		template: PropTypes.string,
		created: PropTypes.string,
		modified: PropTypes.string,
		dataElementsCount: PropTypes.number,
		attachmentsCount: PropTypes.number,
	})
};
